[
  {
    "id": "001",
    "originalId": "001",
    "title": "The First Wound",
    "chapter": "Battlefield",
    "status": "published",
    "url": "https://thefinnanfiles.com/read/001/",
    "image": "/images/panels/001.jpeg",
    "width": 1024,
    "height": 1536,
    "text": "Captain Finnan marched with the regulars toward the frontline. The war was modern, but the mud was ancient. Then the drone came down from the white sky, and history became personal.\n\nFinnan does not merely survive the blast. \nHe survives it wrong. \nThe hero’s road begins with the loss of his ability to walk it."
  },
  {
    "id": "002",
    "originalId": "002",
    "title": "The Enemy Medic",
    "chapter": "Battlefield",
    "status": "published",
    "url": "https://thefinnanfiles.com/read/002/",
    "image": "/images/panels/002.png",
    "width": 1024,
    "height": 1536,
    "text": "EXT. BATTLEFIELD — AFTERMATH — DAY\n\nThe battlefield lies under a dead white sky. \nAn armoured ambulance crawls through the mud, its AI medic scanning the wreckage without pity, without fear, without hope.\nAcross the field, among the fallen, one signal remains.\n\nAI MEDIC AGENT: \nONE SURVIVOR DETECTED.\n\nIn the distance, Captain Finnan raises his head from the mud. \nHis leg is ruined. His unit is gone. The war has not finished with him.\n\nAI MEDIC AGENT: \nPRIORITY RETRIEVAL INITIATED."
  },
  {
    "id": "003",
    "originalId": "004",
    "title": "Two Targets",
    "chapter": "Battlefield",
    "status": "published",
    "url": "https://thefinnanfiles.com/read/003/",
    "image": "/images/panels/003.png",
    "width": 1024,
    "height": 1536,
    "text": "EXT. BATTLEFIELD — BESIDE THE ENEMY AMBULANCE — DAY\n\nThe AI Medic Agent extends its lifting arms toward Finnan. \nThe armoured ambulance waits with its rear hatch open, patient as a machine and merciless as mercy.\n\nFinnan digs his hands into the mud and refuses to be loaded.\n\nFINNAN: \nYou don’t understand. You and I together — we’re a target.\n\nAbove them, the white sky remains empty for one terrible second.\n\nFINNAN: \nYour drones will shoot me. Our drones will shoot you.\n\nAI MEDIC AGENT: \nWOUNDED COMBATANT MUST BE EVACUATED.\n\nFINNAN: \nThen evacuate yourself first."
  },
  {
    "id": "004",
    "originalId": "005",
    "title": "Mercy by Injection",
    "chapter": "Battlefield",
    "status": "published",
    "url": "https://thefinnanfiles.com/read/004/",
    "image": "/images/panels/004.png",
    "width": 1024,
    "height": 1536,
    "text": "EXT. BATTLEFIELD — BESIDE THE ENEMY AMBULANCE — DAY\n\nThe AI Medic Agent lowers a needle-arm with ceremonial precision.\n\nFinnan tries to pull away, but his ruined leg betrays him. \nThe injector clicks against his skin.\n\nAI MEDIC AGENT: \nOPIOID ANALGESIA ADMINISTERED.\n\nThe pain leaves Finnan like a departing army.\n\nFor one beautiful second, he almost forgives the machine.\n\nFINNAN: \nOh. That is... treacherously excellent.\n\nHe blinks at the empty white sky — still conscious, still angry, now much too comfortable.\n\nFINNAN: \nBut we are still going to be killed, you shiny undertaker.\n\nAI MEDIC AGENT: \nPATIENT DISTRESS REDUCED."
  },
  {
    "id": "005",
    "originalId": "007",
    "title": "The Ditch",
    "chapter": "Battlefield",
    "status": "published",
    "url": "https://thefinnanfiles.com/read/005/",
    "image": "/images/panels/005.png",
    "width": 1024,
    "height": 1536,
    "text": "INT./EXT. ARMOURED AMBULANCE — BATTLEFIELD DITCH — DAY\n\nThe ambulance takes fire from both sides at once.\n\nDrones cut across the sky. \nArtillery opens the earth. \nThe machine that came to save Finnan becomes a target for everyone.\n\nThe left armour buckles. \nThe right wheel assembly tears free.\n\nThe ambulance leaves the road, drops into a ditch, and slams half-submerged into black water.\n\nInside, Finnan hangs crooked in his restraints — soaked, wounded, and offended.\n\nFINNAN: \nI did mention the target problem.\n\nAI MEDIC AGENT: \nVEHICLE INTEGRITY COMPROMISED.\n\nWater climbs over the floor. \nSparks fall like small, useless stars.\n\nFINNAN: \nYes. I feel your diagnosis has caught up with the scenery.\n\nAI MEDIC AGENT: \nEVACUATION PRIORITY REMAINS ACTIVE.\n\nFINNAN: \nGood. Because your ambulance is trying to become a pond."
  }
]